import React, { useState,useEffect } from "react";
import "../Account/jobspace-account.css"; // new JobSpace design system (reskin only)
import {
  Col,
  Container,
  Row,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  Modal,
  ModalBody,
  //Form,
  FormGroup,
  Label,
  Spinner,
  /* Alert, */
  Button
} from "reactstrap";
import axios from 'axios';
import { AppConfiguration } from "read-appsettings-json";
import moment from 'moment';
//import useForm from "./useForm";
import InputGroup from 'react-bootstrap/InputGroup';
import Resizer from "react-image-file-resizer";




import {  Card,   CardBody } from "reactstrap";

import lightLogo from "../../assets/images/logo-light.png";
import darkLogo from "../../assets/images/logo-dark.png";

import signUpImage from "../../assets/images/auth/sign-up.png";
//import useForm from "../../wcomponents/SignUp/useForm";
import Icon from "../../wcomponents/Icon/Icon";
import "../../wcomponents/w.css"
import NavBar from "../../Layout/CommonLayout/NavBar"//"../CommonLayout/NavBar";
import ScrolltoTop from "../../components/ScrolltoTop";
import TopBar from "../../Layout/CommonLayout/TopBar";
import { setSelection } from "@testing-library/user-event/dist/cjs/event/selection/setSelection.js";
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { FormControl } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link, Navigate } from "react-router-dom";
// import Alert from 'react-bootstrap/Alert';
import { useForm } from "react-hook-form";

import {Alert} from "reactstrap";
import AWS from "aws-sdk";


const CompanyDocumentsView = ({submitForm }) => {
    const [userdata, setUserdata] = useState(JSON.parse(sessionStorage.getItem("userdata")));
    const navigate = useNavigate();
    const [pagePath, setPagePath] = useState(true)
    const [show, setShow] = useState(false);
    const [dissableBtn, setDissableBtn] = useState(true);
    const [isChecked, setIsChecked] = useState(false);
    const { errors, register, handleSubmit, control } = useForm();
    const [secCertificate,setSecCertififacte] =useState();
    const [companyArticles, setcompanyArticles] = useState("")
    const [BirCertificate, setBirCertificate] = useState("")
    const [businessPermit, setbusinessPermit] = useState("")
    const [companyOwnerId, setcompanyOwnerId] = useState("")
    const [doleRegistered, setdoleRegistered] = useState("")
    const [peza,setPeza] = useState("")
    const [headerId, setheaderId] = useState("")
    const [arr1, setarr] = useState([])
    
    const [isshow, setisshow] = useState(false)
    const [color, setcolor] = useState("")
    const [message, setmessage] = useState("")
    const [fade, setfade] = useState("")
    const [alerttype, setalerttype] = useState("")
    const [disableSave, setdisableSave] = useState(false);
    const [loading, setLoading] = useState(false);

    const [matchedDocumentUrl, setmatchedDocumentUrl]  = useState("")
    const [matchedDocumentName, setmatchedDocumentName]  = useState("")
    const [matchedDocumentKey, setmatchedDocumentKey] = useState("")

    const [matchedDocumentUrl2, setmatchedDocumentUrl2]  = useState("")
    const [matchedDocumentName2, setmatchedDocumentName2]  = useState("")
    const [matchedDocumentKey2, setmatchedDocumentKey2] = useState("")

    const [matchedDocumentUrl3, setmatchedDocumentUrl3]  = useState("")
    const [matchedDocumentName3, setmatchedDocumentName3]  = useState("")
    const [matchedDocumentKey3, setmatchedDocumentKey3] = useState("")

    const [matchedDocumentUrl4, setmatchedDocumentUrl4]  = useState("")
    const [matchedDocumentName4, setmatchedDocumentName4]  = useState("")
    const [matchedDocumentKey4, setmatchedDocumentKey4] = useState("")

    const [matchedDocumentUrl5, setmatchedDocumentUrl5]  = useState("")
    const [matchedDocumentName5, setmatchedDocumentName5]  = useState("")
    const [matchedDocumentKey5, setmatchedDocumentKey5] = useState("")

    const [matchedDocumentUrl6, setmatchedDocumentUrl6]  = useState("")
    const [matchedDocumentName6, setmatchedDocumentName6]  = useState("")
    const [matchedDocumentKey6, setmatchedDocumentKey6] = useState("")

    const [matchedDocumentUrl7, setmatchedDocumentUrl7]  = useState("")
    const [matchedDocumentName7, setmatchedDocumentName7]  = useState("")
    const [matchedDocumentKey7, setmatchedDocumentKey7] = useState("")

    const [documentShow , setdocumentShow] = useState(false);


    useEffect(
        () => {
            console.log("CompanyDocuments")
            setLoading(true)
          handleGetCompanyChecklist()
        },
        []
    );

    const handleGetCompanyChecklist = async(globalNewId) => {
        console.log("handleGetCompanyChecklist")
        let filter_data = {
          "isDeleted" : "0", 
          "userId" : userdata[0].userid,
          //"isDeleted" : "0",
         /*  "firstName" : firstName,
          "lastName"  : lastName, */
        }
        
        const Params = {
          "_collection" : "CompanyRegisteredCheckList",
          "filter_data" : filter_data
        }
        console.log("Params")
        console.log(Params)
        console.log("s")
         axios
         .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            console.log("res.data")
            console.log(res)
    
            let dataTmp = []
            let a
            let dataaa = res.data
            console.log("data")
            console.log(dataaa)
            let newstr2=""
            dataaa.CompanyRegisteredCheckList.map(function(itm,i){
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                //console.log(json.headerId)
                //setheaderId(json.headerId)
                dataTmp.push(json)
                a = json
            })    
            // setheaderId(dataTmp[0].h)
            //updateCompanyRegisteredCheckList()
            console.log("dataTmp")
            console.log(dataTmp)
            
            
            //let b =  
            setarr(dataTmp)
            if(res.status === 200){
                setLoading(false)
                if(dataTmp.length > 0){
                    setheaderId(dataTmp[0].headerId)
                    //if(dataTmp.data !== undefined){
                        
                        fetchDocumentFromS3sec(dataTmp[0].data)
                        fetchDocumentFromS3caoi(dataTmp[0].data)
                        fetchDocumentFromS3bir(dataTmp[0].data)
                        fetchDocumentFromS3bp(dataTmp[0].data)
                        fetchDocumentFromS3coi(dataTmp[0].data)
                        fetchDocumentFromS3dole(dataTmp[0].data)
                        fetchDocumentFromS3peza(dataTmp[0].data)
                    //}
                   
                    
                }
                
            }
        })
        .catch(error =>{
            alert("error: " + error)
            setLoading(false)
        })
    };

    const  fetchDocumentFromS3sec = (dataTmp) => {
        let secNewId = ""
        let secName = ""
        dataTmp.forEach(element => {
            if(element.id==="0"){
                    secNewId   = element.newId
                    secName = element.name
            }
        });
        setmatchedDocumentName(secName)
       // const newId = dataTmp[0].newId; 
    
        return new Promise((resolve, reject) => {
            AWS.config.update({
                
                accessKeyId: AppConfiguration.Setting().accessKeyId,
                secretAccessKey: AppConfiguration.Setting().secretAccessKey, 
                region: 'us-east-1'
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
                //Key : newId,
            };
    
            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    console.log("Error fetching documents from S3: ", err);
                    reject(err);
                } else {
                   
                    const s3objects = data.Contents;
                    console.log("s3objects");
                    console.log(s3objects);
    
                    let matchFound = false;
    
                    for (const object of s3objects) {
                        const key = object.Key;
                        console.log("key------------")
                        console.log(key)

                        const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                        const last14Digits = keyWithoutExtension.slice(-14);
                        matchFound = true;
                        if (key === secNewId) {
                            const keyWithoutLast14Digits = key.replace(/-\d{14}(\.\w+)$/, '$1');
                            handleMatchedDocument(key);
                            break; 
                        }
                    }
    
                    if (!matchFound) {
                        console.log("No match found for newId: ", secNewId);
                    }
    
                    resolve(data.Contents);
                }
            });
        });
    };
    const  fetchDocumentFromS3caoi = (dataTmp) => {
        let caioNewId = ""
        let caioName = ""
        dataTmp.forEach(element => {
            if(element.id==="1"){
                    caioNewId   = element.newId
                    caioName = element.name
            }
            setmatchedDocumentName2(caioName)
        });
       // const newId = dataTmp[0].newId; 
    
        return new Promise((resolve, reject) => {
            AWS.config.update({
                
                accessKeyId: AppConfiguration.Setting().accessKeyId,
                secretAccessKey: AppConfiguration.Setting().secretAccessKey, 
                region: 'us-east-1'
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
                //Key : newId,
            };
    
            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    console.log("Error fetching documents from S3: ", err);
                    reject(err);
                } else {
                   
                    const s3objects = data.Contents;
                    console.log("s3objects");
                    console.log(s3objects);
    
                    let matchFound = false;
    
                    for (const object of s3objects) {
                        const key = object.Key;
                        const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                        const last14Digits = keyWithoutExtension.slice(-14);
                        matchFound = true;
                        if (key === caioNewId) {
                            const keyWithoutLast14Digits = key.replace(/-\d{14}(\.\w+)$/, '$1');
                            handleMatchedDocument2(key);
                            break; 
                        }
                    }
    
                    if (!matchFound) {
                        console.log("No match found for newId: ", caioNewId);
                    }
    
                    resolve(data.Contents);
                }
            });
        });
    };
    const  fetchDocumentFromS3bir = (dataTmp) => {
        console.log("dataTmp fetchDocumentFromS3bir")
        console.log(dataTmp)
        let birNewId = ""
        let birName = ""
        dataTmp.forEach(element => {
            if(element.id==="2"){
                    birNewId   = element.newId
                    birName = element.name
            }
            
            setmatchedDocumentName3(birName)
        });
        console.log(birName)
       // const newId = dataTmp[0].newId; 
    
        return new Promise((resolve, reject) => {
            AWS.config.update({
                
                accessKeyId: AppConfiguration.Setting().accessKeyId,
                secretAccessKey: AppConfiguration.Setting().secretAccessKey, 
                region: 'us-east-1'
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
                //Key : newId,
            };
    
            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    console.log("Error fetching documents from S3: ", err);
                    reject(err);
                } else {
                   
                    const s3objects = data.Contents;
                    console.log("s3objects");
                    console.log(s3objects);
    
                    let matchFound = false;
    
                    for (const object of s3objects) {
                        const key = object.Key;
                        const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                        const last14Digits = keyWithoutExtension.slice(-14);
                        matchFound = true;
                        if (key === birNewId) {
                            const keyWithoutLast14Digits = key.replace(/-\d{14}(\.\w+)$/, '$1');
                            handleMatchedDocument3(key);
                            break; 
                        }
                    }
    
                    if (!matchFound) {
                        console.log("No match found for newId: ", birNewId);
                    }
    
                    resolve(data.Contents);
                }
            });
        });
    };
    const  fetchDocumentFromS3bp = (dataTmp) => {
        console.log("dataTmp fetchDocumentFromS3bir")
        console.log(dataTmp)
        let bpNewId = ""
        let bpName = ""
        dataTmp.forEach(element => {
            if(element.id==="3"){
                    bpNewId   = element.newId
                    bpName = element.name
            }
            setmatchedDocumentName4(bpName)
        });
       // const newId = dataTmp[0].newId; 
    
        return new Promise((resolve, reject) => {
            AWS.config.update({
                
                accessKeyId: AppConfiguration.Setting().accessKeyId,
                secretAccessKey: AppConfiguration.Setting().secretAccessKey, 
                region: 'us-east-1'
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
                //Key : newId,
            };
    
            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    console.log("Error fetching documents from S3: ", err);
                    reject(err);
                } else {
                   
                    const s3objects = data.Contents;
                    console.log("s3objects");
                    console.log(s3objects);
    
                    let matchFound = false;
    
                    for (const object of s3objects) {
                        const key = object.Key;
                        const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                        const last14Digits = keyWithoutExtension.slice(-14);
                        matchFound = true;
                        if (key === bpNewId) {
                            const keyWithoutLast14Digits = key.replace(/-\d{14}(\.\w+)$/, '$1');
                            handleMatchedDocument4(key);
                            break; 
                        }
                    }
    
                    if (!matchFound) {
                        console.log("No match found for newId: ", bpNewId);
                    }
    
                    resolve(data.Contents);
                }
            });
        });
    };
    const  fetchDocumentFromS3coi = (dataTmp) => {
        console.log("dataTmp fetchDocumentFromS3bir")
        console.log(dataTmp)
        let coiNewId = ""
        let coiName = ""
        dataTmp.forEach(element => {
            if(element.id==="4"){
                    coiNewId   = element.newId
                    coiName = element.name
            }
            setmatchedDocumentName5(coiName)
        });
       // const newId = dataTmp[0].newId; 
    
        return new Promise((resolve, reject) => {
            AWS.config.update({
                
                accessKeyId: AppConfiguration.Setting().accessKeyId,
                secretAccessKey: AppConfiguration.Setting().secretAccessKey, 
                region: 'us-east-1'
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
                //Key : newId,
            };
    
            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    console.log("Error fetching documents from S3: ", err);
                    reject(err);
                } else {
                   
                    const s3objects = data.Contents;
                    console.log("s3objects");
                    console.log(s3objects);
    
                    let matchFound = false;
    
                    for (const object of s3objects) {
                        const key = object.Key;
                        const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                        const last14Digits = keyWithoutExtension.slice(-14);
                        matchFound = true;
                        if (key === coiNewId) {
                            const keyWithoutLast14Digits = key.replace(/-\d{14}(\.\w+)$/, '$1');
                            handleMatchedDocument5(key);
                            break; 
                        }
                    }
    
                    if (!matchFound) {
                        console.log("No match found for newId: ", coiNewId);
                    }
    
                    resolve(data.Contents);
                }
            });
        });
    };
    const  fetchDocumentFromS3dole = (dataTmp) => {
        console.log("dataTmp fetchDocumentFromS3bir")
        console.log(dataTmp)
        let doleNewId = ""
        let doleName = ""
        dataTmp.forEach(element => {
            if(element.id==="5"){
                    doleNewId   = element.newId
                    doleName = element.name
            }
            setmatchedDocumentName6(doleName)
        });
       // const newId = dataTmp[0].newId; 
    
        return new Promise((resolve, reject) => {
            AWS.config.update({
                
                accessKeyId: AppConfiguration.Setting().accessKeyId,
                secretAccessKey: AppConfiguration.Setting().secretAccessKey, 
                region: 'us-east-1'
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
                //Key : newId,
            };
    
            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    console.log("Error fetching documents from S3: ", err);
                    reject(err);
                } else {
                   
                    const s3objects = data.Contents;
                    console.log("s3objects");
                    console.log(s3objects);
    
                    let matchFound = false;
    
                    for (const object of s3objects) {
                        const key = object.Key;
                        const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                        const last14Digits = keyWithoutExtension.slice(-14);
                        matchFound = true;
                        if (key === doleNewId) {
                            const keyWithoutLast14Digits = key.replace(/-\d{14}(\.\w+)$/, '$1');
                            handleMatchedDocument6(key);
                            break; 
                        }
                    }
    
                    if (!matchFound) {
                        console.log("No match found for newId: ", doleNewId);
                    }
    
                    resolve(data.Contents);
                }
            });
        });
    };
    const  fetchDocumentFromS3peza = (dataTmp) => {
        console.log("dataTmp fetchDocumentFromS3bir")
        console.log(dataTmp)
        let pezaNewId = ""
        let pezaName = ""
        dataTmp.forEach(element => {
            if(element.id==="6"){
                    pezaNewId   = element.newId
                    pezaName = element.name
            }
            setmatchedDocumentName7(pezaName)
        });
       // const newId = dataTmp[0].newId; 
    
        return new Promise((resolve, reject) => {
            AWS.config.update({
                
                accessKeyId: AppConfiguration.Setting().accessKeyId,
                secretAccessKey: AppConfiguration.Setting().secretAccessKey, 
                region: 'us-east-1'
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
                //Key : newId,
            };
    
            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    console.log("Error fetching documents from S3: ", err);
                    reject(err);
                } else {
                   
                    const s3objects = data.Contents;
                    console.log("s3objects");
                    console.log(s3objects);
    
                    let matchFound = false;
    
                    for (const object of s3objects) {
                        const key = object.Key;
                        const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                        const last14Digits = keyWithoutExtension.slice(-14);
                        matchFound = true;
                        if (key === pezaNewId) {
                            const keyWithoutLast14Digits = key.replace(/-\d{14}(\.\w+)$/, '$1');
                            handleMatchedDocument7(key);
                            break; 
                        }
                    }
    
                    if (!matchFound) {
                        console.log("No match found for newId: ", pezaNewId);
                    }
    
                    resolve(data.Contents);
                }
            });
        });
    };

    const handleMatchedDocument = (objectKey) => {
        console.log("objectKey")
        console.log(objectKey)
        const baseUrl = "https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/";
        const fullUrl = `${baseUrl}${objectKey}`;
        
        //console.log("Matched Document URL: ", fullUrl);
        
        const originalDocumentName = objectKey.split('/').pop();
        //console.log("Original Document Name:", originalDocumentName);
        
        const matchedDocumentName = originalDocumentName.replace(/-\d{14}\.pdf$/, '.pdf');
       // console.log("Formatted Document Name:", matchedDocumentName);

        setmatchedDocumentUrl(fullUrl)
        //setmatchedDocumentName(matchedDocumentName)
        setmatchedDocumentKey(objectKey)
        
    };
    const handleMatchedDocument2 = (objectKey) => {
        const baseUrl = "https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/";
        const fullUrl = `${baseUrl}${objectKey}`;
        
        console.log("Matched Document URL: ", fullUrl);
        
        const originalDocumentName = objectKey.split('/').pop();
        console.log("Original Document Name:", originalDocumentName);
        
        const matchedDocumentName = originalDocumentName.replace(/-\d{14}\.pdf$/, '.pdf');
        console.log("Formatted Document Name:", matchedDocumentName);

        setmatchedDocumentUrl2(fullUrl)
        //setmatchedDocumentName2(matchedDocumentName)
        setmatchedDocumentKey2(objectKey)
        
    };
    const handleMatchedDocument3 = (objectKey) => {
        const baseUrl = "https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/";
        const fullUrl = `${baseUrl}${objectKey}`;
        
        console.log("Matched Document URL: ", fullUrl);
        
        const originalDocumentName = objectKey.split('/').pop();
        console.log("Original Document Name:", originalDocumentName);
        
        const matchedDocumentName = originalDocumentName.replace(/-\d{14}\.pdf$/, '.pdf');
        console.log("Formatted Document Name:", matchedDocumentName);

        setmatchedDocumentUrl3(fullUrl)
        //setmatchedDocumentName2(matchedDocumentName)
        setmatchedDocumentKey3(objectKey)
        
    };
    const handleMatchedDocument4 = (objectKey) => {
        const baseUrl = "https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/";
        const fullUrl = `${baseUrl}${objectKey}`;
        
        console.log("Matched Document URL: ", fullUrl);
        
        const originalDocumentName = objectKey.split('/').pop();
        console.log("Original Document Name:", originalDocumentName);
        
        const matchedDocumentName = originalDocumentName.replace(/-\d{14}\.pdf$/, '.pdf');
        console.log("Formatted Document Name:", matchedDocumentName);

        setmatchedDocumentUrl4(fullUrl)
        //setmatchedDocumentName2(matchedDocumentName)
        setmatchedDocumentKey4(objectKey)
        
    };
    const handleMatchedDocument5 = (objectKey) => {
        const baseUrl = "https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/";
        const fullUrl = `${baseUrl}${objectKey}`;
        
        console.log("Matched Document URL: ", fullUrl);
        
        const originalDocumentName = objectKey.split('/').pop();
        console.log("Original Document Name:", originalDocumentName);
        
        const matchedDocumentName = originalDocumentName.replace(/-\d{14}\.pdf$/, '.pdf');
        console.log("Formatted Document Name:", matchedDocumentName);

        setmatchedDocumentUrl5(fullUrl)
        //setmatchedDocumentName2(matchedDocumentName)
        setmatchedDocumentKey5(objectKey)
        
    };
    const handleMatchedDocument6 = (objectKey) => {
        const baseUrl = "https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/";
        const fullUrl = `${baseUrl}${objectKey}`;
        
        console.log("Matched Document URL: ", fullUrl);
        
        const originalDocumentName = objectKey.split('/').pop();
        console.log("Original Document Name:", originalDocumentName);
        
        const matchedDocumentName = originalDocumentName.replace(/-\d{14}\.pdf$/, '.pdf');
        console.log("Formatted Document Name:", matchedDocumentName);

        setmatchedDocumentUrl6(fullUrl)
        //setmatchedDocumentName2(matchedDocumentName)
        setmatchedDocumentKey6(objectKey)
        
    };
    const handleMatchedDocument7 = (objectKey) => {
        const baseUrl = "https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/";
        const fullUrl = `${baseUrl}${objectKey}`;
        
        console.log("Matched Document URL: ", fullUrl);
        
        const originalDocumentName = objectKey.split('/').pop();
        console.log("Original Document Name:", originalDocumentName);
        
        const matchedDocumentName = originalDocumentName.replace(/-\d{14}\.pdf$/, '.pdf');
        console.log("Formatted Document Name:", matchedDocumentName);

        setmatchedDocumentUrl7(fullUrl)
        //setmatchedDocumentName2(matchedDocumentName)
        setmatchedDocumentKey7(objectKey)
        
    };

    const handleCheckBox =(event)=>{
        console.log(event.target.checked)
        if(event.target.checked === true){
            setIsChecked(true)
            setDissableBtn(false)
            //setAgree("YES")
            //console.log("yes")
          }else{
            setIsChecked(false)
            setDissableBtn(true)
            //setAgree("NO")
            //console.log("no")
          }
    };

    const updateDoc=()=>{
        setLoading(true)
        navigate("/CompanyDocumentsEdit")
    }

    return (
        <React.Fragment  >
         {/*  <TopBar /> */}
           <NavBar />
          <div className="jsa-root" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: "#f4f7f4", minHeight: "100vh", color: "#16271f", padding: "30px 0 60px" }}>

                  <Container fluid='true' >
                   
                   <Row className="mt-3"></Row>
                   <Row className="mt-3"></Row>
                   
                    <Row className="justify-content-center">
                    
                    <Col sm={5} >
                        <div className="CRcard-two" style={{ background: "#fff", border: "1.5px solid #e8ede9", borderRadius: 18, boxShadow: "0 8px 26px rgba(20,50,38,.05)", padding: 26 }}>
                           <Form /* onSubmit={handleSubmit(onFormSubmit)} */>
                                <Alert isOpen={isshow} color={color} fade={fade} className={isshow ? 'display-block' : 'display-none'}>
                                    <div className={color}></div> 
                                    {message}
                                </Alert>
                                <Row>
                                    <Form.Text className=" ml5percent mt-4 ">To ensure the legitimacy of your company and the job hiring you posted,</Form.Text>
                                </Row>
                                <Row>
                                    <Form.Text className="ml5percent  ">below list of company documents are required</Form.Text>
                                </Row>
                                <Row>
                                <h4 className=" ccpLabel mt-4 mb-2" style={{ color: "#16271f", fontSize: 20, fontWeight: 800, letterSpacing: "-.01em" }}>Uploaded Company Documents (view)</h4>
                                </Row>
                                <Row className="mt-3">
                                    <Col>
                                        <Form.Label className="ml5percent mt-2">SEC Certificate of Registration</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        {matchedDocumentName && (
                                            <a 
                                                //className="mt-5"
                                                href={`https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/${matchedDocumentKey}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                            >
                                                {matchedDocumentName}
                                            </a>
                                        )}
                                    </Col>
                                    <Col sm={1}></Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">Company Articles of Incorporation</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        {matchedDocumentName2 && (
                                            <a 
                                                //className="mt-5"
                                                href={`https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/${matchedDocumentKey2}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                            >
                                                {matchedDocumentName2}
                                            </a>
                                        )}
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">BIR Certificate of Registration </Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        {matchedDocumentName3 && (
                                            <a 
                                                //className="mt-5"
                                                href={`https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/${matchedDocumentKey3}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                            >
                                                {matchedDocumentName3}
                                            </a>
                                        )}
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">Business Permit</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                            {matchedDocumentName4 && (
                                            <a 
                                                //className="mt-5"
                                                href={`https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/${matchedDocumentKey4}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                            >
                                                {matchedDocumentName4}
                                            </a>
                                        )}
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">Company Owner/President ID </Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        {matchedDocumentName5 && (
                                            <a 
                                                //className="mt-5"
                                                href={`https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/${matchedDocumentKey5}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                            >
                                                {matchedDocumentName5}
                                            </a>
                                        )}
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">DOLE Registration</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        {matchedDocumentName6 && (
                                            <a 
                                                //className="mt-5"
                                                href={`https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/${matchedDocumentKey6}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                            >
                                                {matchedDocumentName6}
                                            </a>
                                        )}
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={6}>
                                        <Form.Label className="ml5percent mt-2">PEZA/Free Port Certificate (Optional)</Form.Label>
                                    </Col>
                                    <Col sm={5}>
                                        {matchedDocumentName7 && (
                                            <a 
                                                //className="mt-5"
                                                href={`https://job-space-bucket-noser-cdr.s3.us-east-1.amazonaws.com/${matchedDocumentKey7}`} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                            >
                                                {matchedDocumentName7}
                                            </a>
                                        )}
                                    </Col>
                                </Row>
                                {/* <div className=" mb-1 margincheck form-check mt-5">
                                    <Input
                                    
                                      className=" form-check-input"
                                      type="checkbox"
                                      //id="flexCheckDefault"
                                      onChange={handleCheckBox}
                                      //value={isChecked}
                                      name="isChecked"
                                      //isValid
                                    />
                                    <p
                                      className=" checktxt form-check-label"
                                      htmlFor="flexCheckDefault"
                                     
                                    >
                                      By clicking �SUBMIT� you confirm that the details and documents
                                        stated and uploaded are correct  and true. You also agree to 
                                        JobSpace�s Privacy  Policy, on collection of personal data ensures
                                        veracity of corporate documents prior to use of JobSpace
                                        job posting features{" "}
                                    </p>
                                    <text
                                      className=" checktxt form-check-label"
                                      htmlFor="flexCheckDefault"
                                     
                                    >
                                        
                                    </text>
                                </div> */}
                                <div className="center">
                                    <Button
                                        //type="submit"
                                        style={{ marginLeft : "90px", background: "#009b57", border: "none", borderRadius: 100, fontWeight: 700, padding: "10px 24px", boxShadow: "0 4px 12px rgba(0,154,87,.28)" }}
                                        className="btn btn-hover mr-auto mb-3 mt-5"
                                        color="success"
                                        size="sm"
                                        onClick={updateDoc}
                                        //disabled={dissableBtn}
                                    >
                                        {loading ? <Spinner size="lg" color="light" /> : "UPDATE DOCS"}
                                    </Button>
                                </div>                               
                           </Form>
                        </div>
                    </Col>

                        
                      
                    </Row>
                  </Container>
                
                  <ScrolltoTop />
          </div>
        </React.Fragment>
      );

}

export default CompanyDocumentsView;